import { render, staticRenderFns } from "./textComponent.vue?vue&type=template&id=57d83e7e&scoped=true&"
import script from "./textComponent.vue?vue&type=script&lang=js&"
export * from "./textComponent.vue?vue&type=script&lang=js&"
import style0 from "./textComponent.vue?vue&type=style&index=0&id=57d83e7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d83e7e",
  null
  
)

export default component.exports